import type { Step } from './types';
import type { Edition, Meter, SelectableAppTypes } from '../calculator/types';

export const STEP_ORDER: Step[] = ['usage', 'needs', 'estimate', 'allowance', 'summary'];

export const EDITION_KEYS: Edition[] = ['free', 'standard', 'premium', 'enterprise'];

/**
 * Which apps are selectable on the Allowance step for each meter.
 * `csResolutions` has no entry because that meter skips the allowance step
 * entirely (users go directly from Estimate → Summary).
 */
export const METER_ALLOWED_APPS: Record<Meter, SelectableAppTypes[] | null> = {
	assetsObjects: ['jira', 'jsm'],
	automations: ['jira', 'jsm', 'confluence', 'jpd'],
	rovoCredits: ['jira', 'jsm', 'confluence'],
	// No allowance step for AI agent resolutions — users skip straight to Summary.
	csResolutions: null,
};
